export default __webpack_public_path__ + "static/i-wp1-d38fbcc54a91043413cea1358ca3d507.png";